import * as React from "react"
import {Grid, Skeleton} from "@mui/material";

import {TABS_TOP} from "../../@constants";
import {useUserActivitiesTops} from "../../@hooks";
import UserActivitiesTopTables from "./Table";
import {userActivitiesTabID} from "../../@signals";


export default function UserActivitiesTopDashboardsDashboards() {
	const KEY = TABS_TOP.DASHBOARD
	const { isLoading, dailyData, submitData, handleExcel } = useUserActivitiesTops(KEY)

	if (KEY !== userActivitiesTabID.value)
		return <></>
	if (!isLoading && (!dailyData.length || !submitData.length))
		return <></>
    if (isLoading)
        return <Skeleton variant="rectangular" height={500} />

	return <>
		<Grid item xs={6}>
			<UserActivitiesTopTables
                showActiveUsers
                title="Top Dashboards"
                data={dailyData}
                isLoading={isLoading}
                api={KEY}
                onDownload={handleExcel}
            />
		</Grid>

		<Grid item xs={6}>
			<UserActivitiesTopTables
                title="Top Dashboards by activity"
                label="Submits"
                data={submitData}
                isLoading={isLoading}
                api={KEY}
                onDownload={handleExcel}
            />
		</Grid>
	</>
}